import { Component } from "@angular/core";
import {
  IonicPage,
  LoadingController,
  NavController,
  NavParams,
} from "ionic-angular";
import { ShopperBuySocialPayScanConfirmPage } from "../shopper-buy-social-pay-scan-confirm/shopper-buy-social-pay-scan-confirm";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { ServiceProvider } from "../../providers/service/service";
import { Http, RequestOptions, Headers } from "@angular/http";
import { Storage } from "@ionic/storage";

/**
 * Generated class for the ShopperBuySocialPayInputPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: "page-shopper-buy-social-pay-input",
  templateUrl: "shopper-buy-social-pay-input.html",
})
export class ShopperBuySocialPayInputPage {
  private code: FormGroup;
  theme = 1;
  social_mission = "";
  social_group = "";
  items = [];
  plaza_id = "";

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private formBuilder: FormBuilder,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    private translateService: TranslateService,
    private loadingCtrl: LoadingController
  ) {
    this.code = this.formBuilder.group({
      val: ["", Validators.compose([Validators.required])],
    });

    this.social_mission = this.navParams.data.social_mission;
    this.social_group = this.navParams.data.social_group;
    this.items = this.navParams.data.items;
    this.plaza_id = this.navParams.data.plaza_id;
    // console.log("data", this.navParams.data);
  }

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");
  }

  /** submit code */
  confirm() {
    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });

    if (!this.code.value.val) {
      this.translateService
        .get("Code must not be empty.")
        .subscribe((value) => {
          this.services.presentToast(value);
        });
      return false;
    } else {
      loader.present();

      this.storage.get("token").then((token) => {
        var link = this.services.URLShopperBuySocial; // change link
        var headers = new Headers();
        headers.append("Accept", "application/json");
        headers.append("Authorization", "Bearer " + token);
        const requestOptions = new RequestOptions({ headers: headers });
        this.http
          .post(
            link,
            {
              plaza_id: this.plaza_id,
              code: this.code.value.val,
              social_group: this.social_group,
              items: this.items,
            },
            requestOptions
          )
          .map((res) => res.json())
          .subscribe(
            (data) => {
              loader.dismiss();
              this.navCtrl.push(ShopperBuySocialPayScanConfirmPage, {
                code: this.code.value.val,
                social_group: this.social_group,
                items: this.items,
                data: data,
                plaza_id: this.plaza_id,
              });
            },
            (error) => {
              var response = JSON.parse(error._body);
              this.translateService.get(response.message).subscribe((value) => {
                this.services.presentToast(value);
              });
              loader.dismiss();
            }
          );
      });
    }
  }

  backPage() {
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/shopper-buy-social-pay-input/shopper-buy-social-pay-input.ts